

<template>
<App class="pm-editor">
   <AppBar>
      <div class="flex-wrap">
        <BaseIcon icon="lianjieliu" style="margin-right:5px" :size="20" color="var(--primary)" />
        <a>{{ flow.name }} </a>
        <Divider type="vertical" />
        <span style="color:var(--primary);font-weight:bold;">
          {{flowData.name}}
          <BaseVersion style="margin-left:5px" :value="parseInt(flowData.version)" />
        </span>
      </div>
      <div class="flex-wrap">

      </div>
      <div class="flex-wrap split5">
        <AppAvatar />
        <Divider type="vertical" />
        <Button type="primary" @click="handleSave">保存并上传</Button>
      </div>
    </AppBar>
   <AppMaskLoading :loading="loading" />

    <AppClient style="bottom:30px">
      <FlowContent ref='fl' :flow-def="flow" :flow="flowData" @on-submit="Submit"
      @on-refresh="getData" />

    </AppClient>
    <AppStatusBar>
      <div class="flex-wrap split10" style="font-size:12px">
      <div>正在编辑</div>
      <div>节点:{{flowData.nodes.length}}</div>
      <div>连接:{{flowData.edges.length}}</div>
      </div>
      <div></div>
    </AppstatusBar>
  </App>
</template>

<script>
import responsableMixin from '@/mixins/responsable';
import App from '@/components/app/app';
import AppBar from '@/components/app/bar';
import AppMaskLoading from '@/components/app/mask-loading';
import FlowLeft from '@/components/flow/editor/left';
import AppRight from '@/components/app/right';
import AppAvatar from '@/components/app/avatar';
import AppClient from '@/components/app/client';
import IconButton from '@/components/app/IconButton';
import IconTabs from '@/components/app/IconTabs';
import TaskMenu from '@/components/task/app/bar/TaskMenu';
import TaskFileName from '@/components/task/app/bar/TaskFileName';
import FlowContent from '@/components/flow/editor/content';
import AppStatusBar from '@/components/app/status-bar';
import cloneDeep from 'lodash';
import UTIL from '@/utils';
export default {
  components: {App, AppStatusBar, AppBar, AppMaskLoading, FlowLeft, AppRight, AppClient, AppAvatar, IconButton, IconTabs, TaskMenu, TaskFileName, FlowContent},
  data() {
    return {
      loading: false,
      showMenu: true,
      showDrawerInput: false,
      view: 'task',
      flow: {},
      version: {},
      flowData: {
        nodes: [],
        edges: [],
      },
    };
  },
  mounted() {
    this.$api.afterLogin(()=>{
      this.getData();
    });
  },
  mixins: [responsableMixin],
  watch: {
    $route: {
      handler(v) {
        this.$api.afterLogin(()=>{
          this.getData();
        });
      },
      immediate: true,
      deep: true,
    },
  },
  activated() {
    this.$nextTick((e)=>{
      this.calcLayout();
    });
  },
  computed: {
    showHelper() {
      return this.selected && this.selected.id;
    },
    views() {
      const _views = [{
        key: 'task',
        name: '执行',
        icon: 'md-create',
      }, {
        key: 'flow',
        name: '流程',
        icon: 'lianjieliu',
      }, {
        key: 'gantte',
        name: '管理',
        icon: 'xiangmu',
      }, {
        key: 'file',
        name: '资料',
        icon: 'folder',
      }, {
        key: 'share',
        name: '分享',
        icon: 'share1',
      }];
      let o = _views;
      if (!this.selected.flow) {
        o = o.filter((v) => v.key != 'flow');
        if (!this.subs || this.subs.length == 0) {
          o = o.filter((v) => v.key != 'gantte');
        }
      }

      return o;
    },

    admin() {
      return this.role == 'admin';
    },
    permissions() {
      if (this.role == 'admin') {
        return true;
      } else {
        return {

        };
      }
    },
  },
  methods: {
    FormatNode(n) {
      return {
        id: n.id,
        option: {
          ...n.properties,
        },
        graph: {
          x: n.x,
          y: n.y,
          type: n.type,
          text: n.text,
        },
      };
    },
    FormatEdge(e) {
      return {
        id: e.id,
        option: e.properties,
        from: e.sourceNodeId,
        to: e.targetNodeId,
        graph: {
          startPoint: e.startPoint,
          endPoint: e.endPoint,
          pointsList: e.pointsList,
          type: e.type,
          text: e.text,
        },
      };
    },
    ParseFlow(flow) {
      return {
        id: flow.id,
        flow_id: flow.flow_id,
        name: flow.name,
        version: flow.version,
        description: flow.description,
        created_by: flow.created_by,
        created_at: flow.created_at,
        nodes: flow.nodes.map((n)=>{
          return {
            id: n.id,
            ...n.graph,
            properties: {
              users: n.users,
              ...n.option,
            },
          };
        }),
        edges: flow.actions.map((e)=>{
          return {
            id: e.id,
            ...e.graph,
            sourceNodeId: e.from,
            targetNodeId: e.to,
            properties: {


            },
          };
        }),
      };
    },
    FormatFlow(flow) {
      let nodes = flow.nodes;
      if (Array.isArray(nodes)) {
        nodes = flow.nodes.map(this.FormatNode);
      } else if (typeof nodes == 'object') {
        // patch
        if (Array.isArray(nodes.create)) {
          nodes.create = nodes.create.map(this.FormatNode);
        }
        if (Array.isArray(nodes.update)) {
          nodes.update = nodes.update.map(this.FormatNode);
        }
      }

      let actions = flow.edges;
      if (Array.isArray(actions)) {
        actions = actions.map(this.FormatEdge);
      } else if (typeof actions == 'object') {
        // patch
        if (actions.create) {
          actions.create = actions.create.map(this.FormatEdge);
        }
        if (actions.update) {
          actions.update = actions.update.map(this.FormatEdge);
        }
      }

      return {
        version: flow.version,
        flow_id: flow.flow_id,
        description: flow.description,
        name: flow.name,
        nodes,
        actions,
      };
    },
    getData() {
      const id = this.$route.params.id;
      const flowId = this.$route.query['flow-id'];
      if (!this.$refs.fl) {
        return;
      }
      this.$refs.fl.setLoading(true);
      if (!flowId) {
        this.Error('请传入flowId');
        return;
      }
      this.flowId = flowId;
      this.timerGetData = this.$api.afterLogin(()=>{
        this.$api.get('oa/flows/'+flowId).then((res)=>{
          this.flow = res.data.data;
        });
        if (id == 'create') {
          this.Init();
          this.$refs.fl.setLoading(false);
        } else {
          this.$api.get(`oa/flow-versions/${id}?related=nodes,actions,acls,forms`).then((res)=>{
            const version = res.data.data;
            this.version = version;
            this.flowData = this.ParseFlow(version);
            console.log(this.flowData);
            this.$refs.fl.Render(this.flowData);
          }).finally(()=>{
            this.$refs.fl.setLoading(false);
          });
        }
      }, this.timerGetData);
    },
    Init() {
      this.flowData = {
        version: 1,
        nodes: [],
        edges: [],
      };
    },
    Update(model) {

    },
    handleSave() {
      const fl = this.$refs.fl;
      if (fl) {
        fl.Save();
      }
    },
    createFlow(model) {
      this.$refs.fl.setLoading(true);
      model.flow_id = this.flowId;
      this.$api.post('oa/flow-versions', this.FormatFlow(model)).then((res)=>{
        const {id} = res.data.data;
        this.$router.replace(this.$route.fullPath.replace('create', id));
      }).catch((e)=>{
        this.Error('错误:'+e);
      }).finally(()=>{
        this.$refs.fl.setLoading(false);
      });
    },
    updateFlow(id, model) {
      const updateData = UTIL.compare_patch_object_final(this.version, this.FormatFlow(model));
      if (!updateData) {
        this.Success('没有进行任何修改');
        this.$refs.fl.setLoading(false);
      }
      this.$api.patch(`oa/flow-versions/${id}`, updateData).then((res)=>{
        this.Success('保存成功');
      }).catch((e)=>{
        this.Error('错误:'+e);
      }).finally(()=>{
        this.$refs.fl.setLoading(false);
      });
    },
    Submit(model) {
      console.log('submit:', model);
      const {id} = this.$route.params;
      if (id == 'create') {
        this.createFlow(model);
      } else {
        if (this.version.instance_count > 0) {
          this.Confirm('此版本已存在实例流程，建议创建一个新的版本', ()=>{
            delete model.id;
            this.createFlow(model);
          });
          return;
        } else {
          this.updateFlow(id, model);
        }
      }
    },
  },
};
</script>

<style lang="less">
.pm-panel-flex{
  display: flex;
}
.pm-panel-editing-wrap:hover{
  filter:brightness(1.2);
  cursor: pointer;
}

.pm-panel-selected{
  background:#fbbd2162 !important;
}

.itask-action-button{
  width:60px;height:60px;background:var(--bg2);margin:5px;border-radius:10px;box-shadow:1px 1px 2px 1px var(--border);padding-top:5px;
  font-size:12px;
  font-weight: bold;
  color:var(--subtext2);
  cursor: pointer;
  transition:all 0.3s;
  border:1px solid var(--border);
}

.itask-action-button:hover{
  filter:brightness(1.05);
}

.itask-action-button:active{
  position: relative;
  right:-1px;
  bottom:-1px;
}
</style>
